import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTMutation } from "../../../utils/useTMutation";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Typography,
  Stack,
  Modal,
  CardContent,
  TextField,
} from "@mui/material";
import JobCard from "../../../components/Job/jobCard";
import JobCardDetails from "../../../components/Job/JobCardDetails";
import jobRoleImage from "../../../assets/images/unsplash_O453M2Liufs.png";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { useTQuery } from "../../../utils/useTQuery";
import Tabs from "../../../components/customTable/Tabs";
import Tooltip from "@mui/material/Tooltip";
import { format, differenceInDays } from "date-fns";
import RequestedJobCardDetails from "../../../components/Job/requestedJobCardDetails";
import showToast from "../../../components/Hot-Toast/showToast";
import {
  getStatusBgColor,
  getStatusColor,
  getStatusonJobCard,
} from "../../../utils/genericMethod";
import {
  setSelectedCard,
  updateSavedJob,
} from "../../../slice/selectedJobCardSlice";
import StarIcon from "@mui/icons-material/Star";
import { useInView } from "react-intersection-observer";
import { usePaginatedQuery } from "../../../utils/usePagination";
import Swal from "sweetalert2";
import copy from "copy-to-clipboard";
import { FRONTEND_URL } from "../../../appConstants";
import "./myjob.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};

export default function MyJobs() {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state?.user);
  const { selectedCard } = useSelector((state) => state.selectedJob);
  const [statusChange, setStatusChnage] = useState();
  const [borderColor, setBorderColor] = useState(null);
  const [values, setValues] = useState({});
  const tabs = [
    { title: "Saved" },
    { title: "Interested" },
    { title: "Offer" },
    { title: "Applied Job Status" },
  ];
  const offerstabs = [
    { title: "Recieved" },
    { title: "Accepted" },
    { title: "Rejected" },
  ];
  const appliedtabs = [
    { title: "Upcoming" },
    { title: "Ongoing" },
    { title: "Completed" },
  ];
  const [active, setActive] = useState(tabs[0]?.title || "Saved");
  const [offerTabactive, setofferTabActive] = useState(
    offerstabs[0]?.title || "Recieve Job Requests",
  );
  const [jobRequestData, setJobRequestData] = useState([]);
  //add for JobCard Details
  const [selectedJob, setSelectedJob] = useState(null);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [showModal, setShowModal] = useState();
  const [jobScheduleExists, setJobScheduleExists] = useState(false);
  // console.log("isDetailsOpen && selectedJob", isDetailsOpen, selectedJob)
  useEffect(() => {
    setShowModal(selectedCard?.showModal1);
  }, [selectedCard?.showModal1]);

  const [appliedTabactive, setappliedTabActive] = useState(
    appliedtabs ? appliedtabs[0]?.title : "",
  );
  const [dataJob, setDataJob] = useState([]);

  const [customFetch, setCustomFetch] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.5, // Adjust this value if needed
  });

  const {
    fetchNextPage,
    data,
    refetch,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
  } = usePaginatedQuery({
    queryKey: ["jobss"],
    url:
      active == "Applied Job Status"
        ? "job/fetchOfferacceptedJob"
        : "job/fetchClinicianJob",
    enabled: true,
    parmeter:
      active !== "Applied Job Status"
        ? {
            USER_ID: userDetails?.ID,
            JOBROLE_ID: userDetails?.JOBROLE_ID,
            ...values,
            ...(active !== "Applied Job Status" && {
              JOB_STATUS: active == "Offer" ? offerTabactive : active,
              SAVED: active == "Saved" ? true : false,
            }),
          }
        : {
            USER_ID: userDetails?.ID,
            JOBROLE_ID: userDetails?.JOBROLE_ID,
            tabDetail: appliedTabactive,
            ...values,
          },
  });

  useEffect(() => {
    refetch();
  }, [active, offerTabactive, appliedTabactive]);

  useEffect(() => {
    if (!customFetch) {
      if (inView && hasNextPage && !isFetchingNextPage) {
        if (data?.pageParams.length !== data.pages?.[0]?.meta?.totalPages) {
          fetchNextPage();
        }
      }
    } else {
      refetch();
      setCustomFetch(false);
    }
  }, [customFetch, inView, fetchNextPage, hasNextPage, isFetchingNextPage]);

  let originalUrl = `${FRONTEND_URL}login?ref=${selectedJob?.ID}`;

  const Copy = () => {
    if (!originalUrl) {
      Swal.fire({
        icon: "error",
        title: "Link Not Found",
        text: "The link could not be copied because it is undefined.",
      });
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(originalUrl)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Link Copied!",
            showConfirmButton: false,
            timer: 1500,
          });
          dispatch(setSelectedCard({ ...selectedCard, showModal1: false }));
        })
        .catch((err) => {
          console.error("Clipboard write failed:", err);
          showManualCopySwal(originalUrl);
        });
    } else {
      showManualCopySwal(originalUrl);
    }
  };

  const showManualCopySwal = (url) => {
    Swal.fire({
      title: "Link Copied!",
      text: `If you're having trouble copying, please manually copy the link provided below:\n${url}`,
      icon: "info",
      confirmButtonText: "Copy the Link",
      customClass: {
        popup: "swal-popup",
        title: "swal-title",
        content: "swal-content",
      },
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      // Attempt manual copy using fallback logic
      copy(originalUrl);
    });
  };

  const saveJobMutation = useTMutation(
    "/job/saveAndRemoveJob",
    "post",
    (response) => {
      if (response.STATUS) {
        return response;
      }
    },
  );

  let divElement = document.querySelector(".heightGet");
  let elemHeight =
    isDetailsOpen && divElement?.offsetHeight === undefined
      ? 998
      : divElement?.offsetHeight;

  const [openRequestedCard, setOpenRequestedCard] = useState(false);

  const handleClose = () => {
    setOpenRequestedCard(false);
  };

  const clinicianResponseToJob = useTMutation(
    "/job/clinicianResponseToJob",
    "post",
    (data) => {
      showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
    },
  );

  //job card details
  const handleCardClick = useCallback(
    (job) => {
      console.log("job", job);
      if (job.SERVICE_TYPE === "One Time") {
        job.JOB_OUT_TIME = job.job_services?.[0]?.JOB_OUT_TIME;
        job.JOB_IN_TIME = job.job_services?.[0]?.JOB_IN_TIME;
      }
      setSelectedJob(job);
      dispatch(setSelectedCard(job));
      setIsDetailsOpen(true);
    },
    [dispatch],
  );

  const handleCloseDetails = useCallback(() => {
    setIsDetailsOpen(false);
    dispatch(setSelectedCard(null));
    setSelectedJob(null);
  }, [dispatch]);
  const handleSaveJob = useCallback(
    async (cardID) => {
      const response = await saveJobMutation.mutateAsync({
        USER_ID: userDetails?.ID,
        JOB_ID: cardID,
      });

      if (response.STATUS) {
        const updatedJob = {
          ...selectedCard,
          save_jobs: selectedCard?.save_jobs?.map((job, idx) =>
            idx === 0
              ? {
                  ...job,
                  SAVED: response?.OUTPUT?.SAVED == true ? true : false,
                }
              : job,
          ),
        };
        dispatch(
          updateSavedJob({
            index: 0,
            saved: response?.OUTPUT?.SAVED == true,
          }),
        );

        refetch();
        setSelectedJob(updatedJob);
        // refetch();
        // setDataJob((prevJobs) =>
        //   prevJobs.map((job) =>
        //     job.ID === cardID ? { ...job, SAVED: response?.OUTPUT?.SAVED } : job
        //   )
        // );
      }
    },
    [saveJobMutation, userDetails],
  );

  if (isLoading) {
    return (
      <Grid
        item
        lg={12}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center", // centers horizontally
          zIndex: 9999,
        }}
      >
        <CircularProgress size={34} /> {/* Bigger size */}
      </Grid>
    );
  }

  const jobId = selectedJob?.ID;

  console.log("data==========", data);

  return (
    <>
      {/* Header */}
      <Grid
        container
        columnSpacing={2}
        px={0}
        pt={6}
        // lg={12}
        sx={{
          background: "white",
          position: "sticky",
          zIndex: 10,
          top: 0,
          width: "100%",
          margin: 0,
          padding: "25px 20px",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
        }}
      >
        <Box
          className="custom-tabs-col"
          sx={{
            pt: 2,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "left",
            gap: "16px",
            padding: "0px 5px",
            mt: 2,
            "@media (max-width: 600px)": {
              flexDirection: "column",
              alignItems: "center",
            },
          }}
        >
          {tabs?.map((tab, i) => (
            <Box
              key={i}
              sx={{
                position: "relative",
                padding: "2px 2px",
                cursor: "pointer",
                "@media (max-width: 600px)": {
                  width: "100%",
                  textAlign: "center",
                },
              }}
              onClick={() => {
                setActive(tab?.title);
                setIsDetailsOpen(false);
              }}
            >
              <Typography
                className={`custom-typography ${
                  active === tab?.title ? "active-tab" : ""
                }`}
                variant="body2"
                color={active === tab?.title ? "success" : "textSecondary"}
              >
                {tab?.title}
              </Typography>
              {active === tab?.title && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "2px",
                    backgroundColor:
                      "linear-gradient(to right,#6ebe44,#4eb3e8)",
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      </Grid>

      <Grid className="custom-tabs-col" container mt={2}>
        {/* ----------------- Saved Tab  starts here -------------------------------- */}

        {active === "Saved" && (
          <Grid
            item
            lg={isDetailsOpen ? 5 : 12}
            className={`${active === "Saved" ? "" : "dNone"}`}
            sx={{
              height: `calc(${1040}px - 250px)`,
              overflow: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "#B7B7B7 transparent",
            }}
          >
            <Grid container spacing={2} mt={2}>
              {data?.pages
                .flatMap((page) => page.OUTPUT)
                .filter((job, index, array) => array.findIndex(j => j.ID === job.ID) === index)
                .map((data, index, array) => {
                  const isJobSaved = data?.save_jobs?.[0]?.SAVED || false;
                  // const isJobSaved = data?.SAVED || false;
                  // console.log("isJobSaved", index, isJobSaved);
                  let isLastElement = index === array?.length - 1;
                  const ClinicianStatus =
                    data?.cliniciansInFacilityJobShifts?.[0]?.clinicianStatus ||
                    "";
                  return (
                    // clinicianWithJob?.clinicianId === userDetails?.ID &&
                    <Grid
                      key={data.ID}
                      ref={isLastElement ? ref : null}
                      item
                      id="index"
                      xs={12}
                      sm={12}
                      md={6}
                      lg={isDetailsOpen ? 12 : 4}
                      marginRight={isDetailsOpen && 0.5}
                      className="clinician-jobs-cards"
                    >
                      {/* <Card
                    sx={{ borderRadius: "8px", height: "100%", border: borderColor === index && "1px solid black", }}>
                    <Box
                      sx={{
                        margin: "0px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                        padding: "0px 2px"
                      }}>
                      <img src={jobRoleImage} alt="" /> */}
                      {/* <StarOutlinedIcon /> */}
                      {/* <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Tooltip title="Save Job">
                          <BookmarkBorderOutlinedIcon
                            key={data.SAVED}
                            style={{ background: isJobSaved ? "linear-gradient(to right,#6ebe44,#4eb3e8)" : "" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSaveJob(data.ID);
                            }}
                          />
                        </Tooltip>
                        <Tooltip title={data?.HIRING_TYPE === "Self Hire" ? 'Open Posted' : 'Sent by Admin'}>
                          <StarIcon
                            style={{
                              color: data?.HIRING_TYPE === "Self Hire" ? 'gray' : 'gold',
                            }}
                          />
                        </Tooltip>
                      </Box>
                    </Box> */}
                      {/* <Stack  direction="row" spacing={2}>
                    <Typography
                      className="montserratFont"
                      sx={{
                        fontSize: "16px",
                        color: "rgba(0,0,0,0.87)",
                        fontWeight: 600,
                      }}>
                      {data.specialty?.SPECIALTY_NAME}
                    </Typography>

                   
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: getStatusColor(ClinicianStatus), // Function to dynamically set color
                          fontWeight: "bold",
                          backgroundColor: getStatusBgColor(ClinicianStatus), // Optional background color
                          padding: "2px 8px",
                          borderRadius: "4px"
                        }}>
                        {getStatusonJobCard(ClinicianStatus)}
                      </Typography>
               
                    </Stack> */}

                      {/* 
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "rgba(0,0,0,0.6)",
                      }}> 
                      {/* {data?.jobs_role?.ROLE_NAME} */}

                      {/* </Typography> */}
                      {/* 
                         <Typography
                      sx={{
                        fontSize: "13px",
                        color: "rgba(0,0,0,0.6)",
                        marginTop:0.2
                      }} px={0.2}> 
                      {data?.user?.FACILITY_NAME} . <span>Glendora, CA</span>
                      </Typography>  */}

                      {/*                    
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "rgba(0,0,0,0.6)",
                      }}> {data?.jobs_role?.ROLE_NAME}</Typography> */}
                      {/* <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        marginTop: "8px"
                      }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: getStatusColor(ClinicianStatus), // Function to dynamically set color
                          fontWeight: "bold",
                          backgroundColor: getStatusBgColor(ClinicianStatus), // Optional background color
                          padding: "2px 8px",
                          borderRadius: "4px"
                        }}>
                        {getStatusonJobCard(ClinicianStatus)}
                      </Typography>
                    </Box> */}
                      {/* <Box
                      sx={{
                        width: "auto",
                        alignItems: "center",
                        display: "flex",
                        fontWeight: 400,
                       marginTop: "6px",
                      }}>
                      <WorkOutlineOutlinedIcon
                        sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }}
                      />
                      <Typography
                        sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)", }}
                        ml={1}>
                        {data?.JOB_TYPE}
                      </Typography>
                    </Box> */}
                      {/* <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        margin: "auto",
                        fontWeight: 400,
                        marginBottom: "6px",
                      }}>
                      <MonetizationOnOutlinedIcon
                        sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }}
                      />
                      <Typography
                        ml={1}
                        sx={{
                          fontSize: "14px",
                          color: "rgba(0,0,0,0.6)",
                          fontWeight: 400,
                          
                        }}>
                          {`$${data.PAY_AMOUNT_FROM}-$${data.PAY_AMOUNT_TO}/hr`}
                        </Typography>
                    </Box> */}

                      {/* <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "left",
                        margin: "auto",
                        padding: "auto",
                      }}> */}
                      {/* <Button sx={{ color: 'rgba(0,0,0,0.7)', fontSize: '12px', border: '1px solid rgba(0,0,0,0.3)' }}>{data?.jobs_role?.ROLE_NAME}</Button> */}
                      {/* <Button
                        className="montserratFont"
                        sx={{
                          color: "rgba(0,0,0,0.7)",
                          fontSize: "12px",
                          border: "1px solid rgba(0,0,0,0.3)",
                          justifyContent: "center",
                          marginRight: "10px",
                          fontWeight: 600,
                          marginTop:0.5
                        }}>
                        {data?.jobs_role?.ROLE_NAME}
                      </Button>
                    </Box> */}
                      {/* <Typography
                      sx={{
                        fontSize: "14px",
                        color: "rgba(0,0,0,0.6)",
                      }}> {data?.jobs_role?.ROLE_NAME}</Typography> */}
                      {/* <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "left",
                        margin: "auto",
                        padding: "auto",
                      }}>
                      {/* <Button sx={{ color: 'rgba(0,0,0,0.7)', fontSize: '12px', border: '1px solid rgba(0,0,0,0.3)' }}>{data?.jobs_role?.ROLE_NAME}</Button> */}
                      {/* <Button
                        className="montserratFont"
                        sx={{
                          color: "rgba(0,0,0,0.7)",
                          fontSize: "12px",
                          border: "1px solid rgba(0,0,0,0.3)",
                          justifyContent: "center",
                          marginRight: "10px",
                          fontWeight: 600,
                        }}>
                        Facility - {data?.user?.FACILITY_NAME}
                      </Button>
                    </Box>  */}
                      {/* <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 0.5,
                      }}>
                      <Typography
                        ml={0.5}
                        sx={{
                          color: "#3BB9E3",
                          fontSize: "12px",
                          fontWeight: 500,
                        }}>
                        {" "}
                        <span className="loraFont">Posted on  {
                          data.CREATED_DATE
                            ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(data.CREATED_DATE).getFullYear()}`
                            : "Latest"
                        }</span>
                      </Typography>

                      <Tooltip title="View Job" >
                        <Typography
                          sx={{
                            color: "rgba(2, 35, 12, 0.7)",
                            fontSize: "14px",
                            fontWeight: 600,
                            cursor: "pointer",
                            // textDecoration: "underline", 
                            border: "1px solid #02230C",
                            borderRadius:"4px",
                            padding:"3px 10px"
                            // Ensures underline styling
                          }}
                          onClick={() => handleCardClick(data)}
                        >
                          {" "}
                          <span className="loraFont"
                          //  setHidden({data: data, index: clinicianWithJob?.clinicianStatus })
                          >
                            {" "}
                            View Job
                          </span>
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Card> */}

                      {/* <!--------------------------------------------------!> */}

                      {/* Latest Save Tab Card Code */}
                      <Card
                        sx={{
                          borderRadius: "8px",
                          marginBottom: 1.5,
                          height: "100%",
                          maxHeight: "240px", // Decreased from 280px
                          padding: "8px", // Reduce padding inside the card
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0 4px",
                          }}
                        >
                          <img
                            src={jobRoleImage}
                            alt="Job Role"
                            style={{ width: "40px", height: "40px" }}
                          />{" "}
                          {/* Decrease image size */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            <Tooltip title="Save Job">
                              <BookmarkBorderOutlinedIcon
                                key={data.SAVED}
                                style={{
                                  background: isJobSaved
                                    ? "linear-gradient(to right,#6ebe44,#4eb3e8)"
                                    : "",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSaveJob(data.ID);
                                }}
                              />
                            </Tooltip>
                            <Tooltip
                              title={
                                data?.HIRING_TYPE === "Self Hire"
                                  ? "Open Posted"
                                  : "Sent by Admin"
                              }
                            >
                              <StarIcon
                                style={{
                                  color:
                                    data?.HIRING_TYPE === "Self Hire"
                                      ? "gray"
                                      : "gold",
                                }}
                              />
                            </Tooltip>
                          </Box>
                        </Box>

                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ paddingX: "8px" }}
                        >
                          <Typography
                            sx={{ fontSize: "14px", fontWeight: 600 }}
                          >
                            {" "}
                            {data.specialty?.SPECIALTY_NAME}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              padding: "1px 6px", // Reduce padding
                              borderRadius: "4px",
                              color: getStatusColor(ClinicianStatus),
                              backgroundColor:
                                getStatusBgColor(ClinicianStatus),
                            }}
                          >
                            {getStatusonJobCard(ClinicianStatus)}
                          </Typography>
                        </Stack>

                        <Typography
                          sx={{
                            fontSize: "12px",
                            marginTop: 0.1,
                            paddingX: "8px",
                          }}
                          px={0.1}
                        >
                          {data?.user?.FACILITY_NAME} .{" "}
                          <span>{`${data?.user?.CITY || ""}${
                            data?.user?.CITY && data?.user?.STATE ? ", " : ""
                          }${data?.user?.STATE || ""}`}</span>
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "6px",
                            paddingX: "8px",
                          }}
                        >
                          <WorkOutlineOutlinedIcon sx={{ fontSize: "14px" }} />
                          <Typography
                            sx={{ fontSize: "12px", marginLeft: 0.8 }}
                          >
                            {data?.JOB_TYPE}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "6px",
                            paddingX: "8px",
                          }}
                        >
                          <MonetizationOnOutlinedIcon
                            sx={{ fontSize: "14px" }}
                          />
                          <Typography
                            sx={{ fontSize: "12px", marginLeft: 0.8 }}
                          >
                            {`$${data.PAY_AMOUNT_FROM}-$${data.PAY_AMOUNT_TO}/hr`}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                            padding: "0px 8px",
                          }}
                        >
                          <Button
                            className="montserratFont"
                            sx={{
                              color: "rgba(0,0,0,0.7)",
                              fontSize: "11px",
                              border: "1px solid rgba(0,0,0,0.3)",
                              justifyContent: "center",
                              fontWeight: 600,
                              marginTop: 1,
                            }}
                          >
                            {data.jobs_role?.ROLE_NAME}
                          </Button>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mt: 1,
                            paddingX: "8px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#3BB9E3",
                              cursor: "pointer",
                            }}
                          >
                            <span className="loraFont">
                              Posted on{" "}
                              {data.CREATED_DATE
                                ? `${new Date(
                                    data.CREATED_DATE,
                                  ).getDate()} ${new Date(
                                    data.CREATED_DATE,
                                  ).toLocaleString("default", {
                                    month: "short",
                                  })} ${new Date(data.CREATED_DATE).getFullYear()}`
                                : "Latest"}
                            </span>
                          </Typography>

                          <Tooltip title="View Job">
                            <Typography
                              sx={{
                                color: "#02230C",
                                fontSize: "12px",
                                cursor: "pointer",
                                // textDecoration: "underline",
                                border: "1px solid #02230C",
                                padding: "3px 10px",
                                borderRadius: "4px",
                              }}
                              onClick={() => handleCardClick(data)}
                            >
                              <span className="loraFont">View Job</span>
                            </Typography>
                          </Tooltip>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        )}

        {/* ----------------- Saved Tab  ends here -------------------------------- */}

        {/* ----------------- Interested In Tab  starts here -------------------------------- */}
        {active === "Interested" && (
          <Grid
            item
            lg={isDetailsOpen ? 5 : 12}
            className={`${active === "Interested" ? "" : "dNone"}`}
            sx={{
              height: `calc(${elemHeight}px - 250px)`,
              overflow: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "#B7B7B7 transparent",
            }}
          >
            <Grid container spacing={2} mt={2}>
              {data?.pages
                .flatMap((page) => page.OUTPUT)
                .filter((job, index, array) => array.findIndex(j => j.ID === job.ID) === index)
                .map((data, index, array) => {
                  const isJobSaved = data?.save_jobs?.[0]?.SAVED || false;
                  const clinicianWithJob =
                    data?.cliniciansInFacilityJobShifts[0];
                  const ClinicianStatus =
                    data?.cliniciansInFacilityJobShifts?.[0]?.clinicianStatus ||
                    "";
                  let isLastElement = index === array?.length - 1;
                  return (
                    <Grid
                      item
                      id="index"
                      ref={isLastElement ? ref : null}
                      xs={12}
                      sm={12}
                      md={6}
                      lg={isDetailsOpen ? 12 : 4}
                    >
                      {/* <Card onClick={() => handleCardClick(data)
                      //  setHidden({ data: data, index: clinicianWithJob?.clinicianStatus })
                    } sx={{ borderRadius: "8px", height: "100%", maxHeight: "270px", cursor: "pointer" }}> */}
                      {/* <Box
                        sx={{
                          margin: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}>
                        <img src={jobRoleImage} alt="" />
                        {/* <StarOutlinedIcon /> */}
                      {/* <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <Tooltip title="Save Job">
                            <BookmarkBorderOutlinedIcon
                              key={data.SAVED}
                              style={{ background: isJobSaved ? "linear-gradient(to right,#6ebe44,#4eb3e8)" : "" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSaveJob(data.ID);
                              }}
                            />
                          </Tooltip> */}
                      {/* <Tooltip title={data?.HIRING_TYPE === "Self Hire" ? 'Open Post' : 'Sent by Admin'}>
                            <StarIcon
                              style={{
                                color: data?.HIRING_TYPE === "Self Hire" ? 'gray' : 'gold',
                              }}
                            />
                          </Tooltip>
                        </Box>
                      </Box>  */}
                      {/* <Stack direction="row" spacing={2}>
                        <Typography
                          className="montserratFont"
                          sx={{
                            fontSize: "16px",
                            color: "rgba(0,0,0,0.87)",
                            fontWeight: 600,
                          }}>
                          {data.specialty?.SPECIALTY_NAME}
                        </Typography> */}
                      {/* 
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: getStatusColor(ClinicianStatus), // Function to dynamically set color
                            fontWeight: "bold",
                            backgroundColor: getStatusBgColor(ClinicianStatus), // Optional background color
                            padding: "2px 8px",
                            borderRadius: "4px"
                          }}>
                          {getStatusonJobCard(ClinicianStatus)}
                        </Typography>
                      </Stack> */}

                      {/* <Typography
                        sx={{
                          fontSize: "14px",
                          color: "rgba(0,0,0,0.6)",
                        }}>
                        {/* {data?.jobs_role?.ROLE_NAME} */}
                      {/* 
                      </Typography>  */}

                      {/* <Typography
                        sx={{
                          fontSize: "13px",
                          color: "rgba(0,0,0,0.6)",
                          marginTop: 0.2
                        }} px={0.2}> {data?.user?.FACILITY_NAME} . <span>Glendora, CA</span></Typography> */}
                      {/* <Typography
                        sx={{
                          fontSize: "14px",
                          color: "rgba(0,0,0,0.6)",
                        }}>{data?.jobs_role?.ROLE_NAME}
                        </Typography>  */}
                      {/* <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          // marginTop: "8px"
                        }}> */}
                      {/* <Typography
                          sx={{
                            fontSize: "14px",
                            color: getStatusColor(ClinicianStatus), // Function to dynamically set color
                            fontWeight: "bold",
                            backgroundColor: getStatusBgColor(ClinicianStatus), // Optional background color
                            padding: "2px 8px",
                            borderRadius: "4px"
                          }}>
                          {getStatusonJobCard(ClinicianStatus)}
                        </Typography> */}
                      {/* </Box> */}
                      {/* <Box
                        sx={{
                          width: "auto",
                          alignItems: "center",
                          display: "flex",
                          fontWeight: 400,
                          marginTop: "2px",
                        }}>
                        <WorkOutlineOutlinedIcon
                          sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }}
                        />
                        <Typography
                          sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }}
                          ml={1}>
                          {data?.JOB_TYPE}
                        </Typography>
                      </Box> */}
                      {/* 
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          margin: "auto",
                          fontWeight: 400,
                          marginBottom: "10px",
                          padding: "0px 1px"
                        }}>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "rgba(0,0,0,0.8)",
                          }}>
                            Status: {ClinicianStatus}
                          </Typography>

                        <Typography

                          sx={{
                            fontSize: "14px",
                            color: "rgba(0,0,0,0.6)",
                            fontWeight: 400,
                          }}>{data?.save_jobs[0]?.STATUS == "New" ? "Application Submitted" : data?.save_jobs[0]?.STATUS}</Typography>
                      </Box> */}
                      {/* <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          margin: "auto",
                          fontWeight: 400,
                          // marginBottom: "10px",
                        }}> */}
                      {/* <MonetizationOnOutlinedIcon
                          sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }}
                        />
                        <Typography
                          ml={1}
                          sx={{
                            fontSize: "14px",
                            color: "rgba(0,0,0,0.6)",
                            fontWeight: 400,

                          }}>{`$${data.PAY_AMOUNT_FROM}-$${data.PAY_AMOUNT_TO}/hr`}</Typography>
                      </Box> */}

                      {/* <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "left",
                          margin: "auto",
                          padding: "auto",
                        }}> */}
                      {/* <Button sx={{ color: 'rgba(0,0,0,0.7)', fontSize: '12px', border: '1px solid rgba(0,0,0,0.3)' }}>{data?.jobs_role?.ROLE_NAME}</Button> */}
                      {/* <Button
                          className="montserratFont"
                          sx={{
                            color: "rgba(0,0,0,0.7)",
                            fontSize: "12px",
                            border: "1px solid rgba(0,0,0,0.3)",
                            justifyContent: "center",
                            marginRight: "10px",
                            fontWeight: 600,
                            marginTop: "6px"
                          }}>
                          {data?.jobs_role?.ROLE_NAME}
                        </Button>
                      </Box> */}
                      {/* <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "left",
                          margin: "auto",
                          padding: "auto",
                        }}>
                        {/* <Button sx={{ color: 'rgba(0,0,0,0.7)', fontSize: '12px', border: '1px solid rgba(0,0,0,0.3)' }}>{data?.jobs_role?.ROLE_NAME}</Button> */}
                      {/* <Button
                          className="montserratFont"
                          sx={{
                            color: "rgba(0,0,0,0.7)",
                            fontSize: "12px",
                            border: "1px solid rgba(0,0,0,0.3)",
                            justifyContent: "center",
                            marginRight: "10px",
                            fontWeight: 600,
                          }}>
                          Facility - {data?.user?.FACILITY_NAME}
                        </Button>
                      </Box>  */}

                      {/* <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 0.7,
                        }}>
                        <Typography
                          ml={0.5}
                          className="loraFont"
                          sx={{
                            color: "#3BB9E3",
                            fontSize: "12px",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}>
                          {" "}
                          <span className="loraFont">Posted on  {
                            data.CREATED_DATE
                              ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(data.CREATED_DATE).getFullYear()}`
                              : "Latest"
                          }</span>
                        </Typography> */}
                      {/* <Button
                                sx={{ color: "#3BB9E3", fontSize: "12px" }}
                               >
                               New
                              </Button> */}
                      {/* <Tooltip title="View Job" >
                          <Typography
                            className="loraFont"
                            // sx={{
                            //   color: "rgba(2, 35, 12, 0.7)",
                            //   fontSize: "15px",
                            //   fontWeight: 500,
                            //   cursor: "pointer",
                            //   border: "1px solid #02230C",
                            //   borderRadius:"4px",
                            //   padding:"3px 10px"
                            // }}

                            sx={{
                              color: "rgba(2, 35, 12, 0.7)",
                              fontSize: "14px",
                              fontWeight: 600,
                              cursor: "pointer",
                              // textDecoration: "underline", 
                              border: "1px solid #02230C",
                              borderRadius: "4px",
                              padding: "3px 10px"
                              // Ensures underline styling
                            }}
                          > */}
                      {/* {" "}
                            <span onClick={() => handleCardClick(data)
                              //  setHidden({ data: data, index: clinicianWithJob?.clinicianStatus })
                            }>
                              {" "}
                              {" "}

                              {/* {new Date().getDate(data.CREATED_DATE) -
                                new Date(new Date()).getDate() || "Latest"} */}
                      {/* {data.CREATED_DATE ? format(new Date(data.CREATED_DATE), 'MMM dd, yyyy') : "Latest"} */}
                      {/* View Job
                            </span>
                          </Typography>
                        </Tooltip>  */}

                      {/* </Box>
                    </Card> */}

                      {/* <!--------------------------------------------!> */}
                      {/* Latest Interested Card Code  */}

                      <Card
                        sx={{
                          borderRadius: "8px",
                          marginBottom: 1.5,
                          height: "100%",
                          // maxHeight: "240px", // Decreased from 280px
                          padding: "10px", // Reduce padding inside the card
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0 4px",
                          }}
                        >
                          <img
                            src={jobRoleImage}
                            alt="Job Role"
                            style={{ width: "40px", height: "40px" }}
                          />{" "}
                          {/* Decrease image size */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            <Tooltip title="Save Job">
                              <BookmarkBorderOutlinedIcon
                                key={data.SAVED}
                                style={{
                                  background: isJobSaved
                                    ? "linear-gradient(to right,#6ebe44,#4eb3e8)"
                                    : "",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSaveJob(data.ID);
                                }}
                              />
                            </Tooltip>
                            <Tooltip
                              title={
                                data?.HIRING_TYPE === "Self Hire"
                                  ? "Open Post"
                                  : "Sent by Admin"
                              }
                            >
                              <StarIcon
                                style={{
                                  color:
                                    data?.HIRING_TYPE === "Self Hire"
                                      ? "gray"
                                      : "gold",
                                }}
                              />
                            </Tooltip>
                          </Box>
                        </Box>

                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ paddingX: "8px" }}
                        >
                          <Typography
                            sx={{ fontSize: "14px", fontWeight: 600 }}
                          >
                            {" "}
                            {data.specialty?.SPECIALTY_NAME}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              padding: "1px 6px", // Reduce padding
                              borderRadius: "4px",
                              color: getStatusColor(ClinicianStatus),
                              backgroundColor:
                                getStatusBgColor(ClinicianStatus),
                            }}
                          >
                            {getStatusonJobCard(ClinicianStatus)}
                          </Typography>
                        </Stack>

                        <Typography
                          sx={{
                            fontSize: "12px",
                            marginTop: 0.1,
                            paddingX: "8px",
                          }}
                          px={0.1}
                        >
                          {data?.user?.FACILITY_NAME} .{" "}
                          <span>Glendora, CA</span>
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "6px",
                            paddingX: "8px",
                          }}
                        >
                          <WorkOutlineOutlinedIcon sx={{ fontSize: "14px" }} />
                          <Typography
                            sx={{ fontSize: "12px", marginLeft: 0.8 }}
                          >
                            {" "}
                            {data?.JOB_TYPE}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "6px",
                            paddingX: "4px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "12px",
                              marginLeft: 0.8,
                              fontWeight: 600,
                            }}
                          >
                            {" "}
                            Status: {ClinicianStatus}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "6px",
                            paddingX: "4px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "12px",
                              marginLeft: 0.8,
                              fontWeight: 600,
                            }}
                          >
                            {data?.save_jobs?.[0]?.STATUS == "New"
                              ? "Application Submitted"
                              : data?.save_jobs?.[0]?.STATUS}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "0px",
                            paddingX: "8px",
                          }}
                        >
                          <MonetizationOnOutlinedIcon
                            sx={{ fontSize: "14px" }}
                          />
                          <Typography
                            sx={{ fontSize: "12px", marginLeft: 0.8 }}
                          >
                            {`$${data.PAY_AMOUNT_FROM}-$${data.PAY_AMOUNT_TO}/hr`}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                            padding: "0px 8px",
                          }}
                        >
                          <Button
                            className="montserratFont"
                            sx={{
                              color: "rgba(0,0,0,0.7)",
                              fontSize: "11px",
                              border: "1px solid rgba(0,0,0,0.3)",
                              justifyContent: "center",
                              fontWeight: 600,
                              marginTop: 1,
                            }}
                          >
                            {data?.jobs_role?.ROLE_NAME}
                          </Button>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mt: 1,
                            paddingX: "8px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#3BB9E3",
                              cursor: "pointer",
                            }}
                          >
                            <span className="loraFont">
                              Posted on{" "}
                              {data.CREATED_DATE
                                ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString("default", { month: "short" })} ${new Date(data.CREATED_DATE).getFullYear()}`
                                : "Latest"}
                            </span>
                          </Typography>

                          <Tooltip title="View Job">
                            <Typography
                              sx={{
                                color: "#02230C",
                                fontSize: "12px",
                                cursor: "pointer",
                                // textDecoration: "underline",
                                border: "1px solid #02230C",
                                padding: "3px 10px",
                                borderRadius: "4px",
                              }}
                              onClick={() => handleCardClick(data)}
                            >
                              <span className="loraFont">View Job</span>
                            </Typography>
                          </Tooltip>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        )}

        {/* ----------------- Interested In Tab Tab  ends here -------------------------------- */}

        {/* ----------------- Offer  Tab starts here -------------------------------- */}

        {active === "Offer" && (
          <Grid
            item
            lg={isDetailsOpen ? 5 : 12}
            className={`${active === "Offer" ? "" : "dNone"}`}
            sx={{
              height: `calc(${elemHeight}px - 250px)`,
              overflow: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "#B7B7B7 transparent",
            }}
          >
            <Grid container spacing={1}>
              {offerstabs?.map((tab) => (
                <Grid item>
                  <Tabs
                    key={tab?.title}
                    title={tab?.title}
                    active={tab?.title === offerTabactive}
                    onClick={() => {
                      setofferTabActive(tab?.title);
                      setIsDetailsOpen(false);
                    }}
                  />
                </Grid>
              ))}
            </Grid>

            {offerTabactive === "Recieved" && (
              <Grid
                container
                className={`${offerTabactive === "Recieved" ? "" : "dNone"}`}
              >
                {data?.pages
                  .flatMap((page) => page.OUTPUT)
                  .filter(
                    (item) =>
                      item?.cliniciansInFacilityJobShifts?.[0]?.offerStatus !==
                        "OfferAccepted" &&
                      item?.cliniciansInFacilityJobShifts?.[0]?.offerStatus !==
                        "OfferRejected",
                  )
                  .filter((job, index, array) => array.findIndex(j => j.ID === job.ID) === index)
                  .map((data, index, array) => {
                    const isJobSaved = data?.save_jobs?.[0]?.SAVED || false;
                    const clinicianWithJob =
                      data?.cliniciansInFacilityJobShifts[0];
                    let isLastElement = index === array?.length - 1;
                    return (
                      <Grid container spacing={2} mt={1}>
                        {
                          <Grid
                            item
                            id="index"
                            ref={isLastElement ? ref : null}
                            xs={12}
                            sm={12}
                            md={6}
                            lg={isDetailsOpen ? 12 : 4}
                          >
                            {/* Latest Offers Received Card Code  */}

                            <Card
                              sx={{
                                borderRadius: "8px",
                                marginBottom: 1.5,
                                height: "100%",
                                maxHeight: "240px", // Decreased from 280px
                                padding: "8px", // Reduce padding inside the card
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "0 4px",
                                }}
                              >
                                <img
                                  src={jobRoleImage}
                                  alt="Job Role"
                                  style={{ width: "40px", height: "40px" }}
                                />{" "}
                                {/* Decrease image size */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2px",
                                  }}
                                >
                                  <Tooltip title="Save Job">
                                    <BookmarkBorderOutlinedIcon
                                      key={data.SAVED}
                                      style={{
                                        background: isJobSaved
                                          ? "linear-gradient(to right,#6ebe44,#4eb3e8)"
                                          : "",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSaveJob(data.ID);
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip
                                    title={
                                      data?.HIRING_TYPE === "Self Hire"
                                        ? "Open Posted"
                                        : "Sent by Admin"
                                    }
                                  >
                                    <StarIcon
                                      style={{
                                        color:
                                          data?.HIRING_TYPE === "Self Hire"
                                            ? "gray"
                                            : "gold",
                                      }}
                                    />
                                  </Tooltip>
                                </Box>
                              </Box>

                              <Stack
                                direction="row"
                                spacing={1}
                                sx={{ paddingX: "8px" }}
                              >
                                <Typography
                                  sx={{ fontSize: "14px", fontWeight: 600 }}
                                >
                                  {" "}
                                  {data.specialty?.SPECIALTY_NAME}
                                </Typography>
                              </Stack>

                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  marginTop: 0.1,
                                  paddingX: "8px",
                                }}
                                px={0.1}
                              >
                                {data?.user?.FACILITY_NAME} .{" "}
                                <span>Glendora, CA</span>
                              </Typography>

                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "6px",
                                  paddingX: "8px",
                                }}
                              >
                                <WorkOutlineOutlinedIcon
                                  sx={{ fontSize: "14px" }}
                                />
                                <Typography
                                  sx={{ fontSize: "12px", marginLeft: 0.8 }}
                                >
                                  {" "}
                                  {data?.JOB_TYPE}{" "}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "left",
                                  padding: "0px 8px",
                                }}
                              >
                                <Button
                                  className="montserratFont"
                                  sx={{
                                    color: "rgba(0,0,0,0.7)",
                                    fontSize: "11px",
                                    border: "1px solid rgba(0,0,0,0.3)",
                                    justifyContent: "center",
                                    fontWeight: 600,
                                    marginTop: 1,
                                  }}
                                >
                                  {data?.jobs_role?.ROLE_NAME}
                                </Button>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mt: 1,
                                  paddingX: "8px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "#3BB9E3",
                                    cursor: "pointer",
                                  }}
                                >
                                  {/* <span className="loraFont">
                          {/* Posted on   */}
                                  {/* {
                          data.CREATED_DATE
                            ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(data.CREATED_DATE).getFullYear()}`
                            : "Latest"
                        }</span> */}
                                  {data.CREATED_DATE
                                    ? format(
                                        new Date(data.CREATED_DATE),
                                        "MMM dd, yyyy",
                                      )
                                    : "Latest"}
                                </Typography>

                                <Tooltip title="View Job">
                                  <Typography
                                    sx={{
                                      color: "#02230C",
                                      fontSize: "12px",
                                      cursor: "pointer",
                                      // textDecoration: "underline",
                                      border: "1px solid #02230C",
                                      padding: "3px 10px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={() => handleCardClick(data)}
                                  >
                                    <span className="loraFont">View Job</span>
                                  </Typography>
                                </Tooltip>
                              </Box>
                            </Card>
                          </Grid>
                        }
                      </Grid>
                    );
                  })}
              </Grid>
            )}

            {offerTabactive === "Accepted" && (
              <Grid
                container
                className={`${offerTabactive === "Accepted" ? "" : "dNone"}`}
              >
                {data?.pages
                  .flatMap((page) => page.OUTPUT)
                  .filter((job, index, array) => array.findIndex(j => j.ID === job.ID) === index)
                  .map((data, index, array) => {
                    const isJobSaved = data?.save_jobs?.[0]?.SAVED || false;

                    const clinicianWithJob =
                      data?.cliniciansInFacilityJobShifts[0];
                    const ClinicianStatus =
                      data?.cliniciansInFacilityJobShifts?.[0]
                        ?.clinicianStatus || "";
                    let isLastElement = index === array?.length - 1;
                    return (
                      <Grid container spacing={2} mt={1}>
                        {
                          <Grid
                            item
                            id="index"
                            ref={isLastElement ? ref : null}
                            xs={12}
                            sm={12}
                            md={6}
                            lg={isDetailsOpen ? 12 : 4}
                          >
                            {/* <Button sx={{ color: 'rgba(0,0,0,0.7)', fontSize: '12px', border: '1px solid rgba(0,0,0,0.3)' }}>{data?.jobs_role?.ROLE_NAME}</Button> */}
                            {/* <!-------------------------------------!> */}

                            {/* Latest Offers Accepted Card Code */}

                            <Card
                              sx={{
                                borderRadius: "8px",
                                marginBottom: 1.5,
                                height: "100%",
                                maxHeight: "240px", // Decreased from 280px
                                padding: "8px", // Reduce padding inside the card
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "0 4px",
                                }}
                              >
                                <img
                                  src={jobRoleImage}
                                  alt="Job Role"
                                  style={{ width: "40px", height: "40px" }}
                                />{" "}
                                {/* Decrease image size */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2px",
                                  }}
                                >
                                  <Tooltip title="Save Job">
                                    <BookmarkBorderOutlinedIcon
                                      key={data.SAVED}
                                      style={{
                                        background: isJobSaved
                                          ? "linear-gradient(to right,#6ebe44,#4eb3e8)"
                                          : "",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSaveJob(data.ID);
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip
                                    title={
                                      data?.HIRING_TYPE === "Self Hire"
                                        ? "Open Posted"
                                        : "Sent by Admin"
                                    }
                                  >
                                    <StarIcon
                                      style={{
                                        color:
                                          data?.HIRING_TYPE === "Self Hire"
                                            ? "gray"
                                            : "gold",
                                      }}
                                    />
                                  </Tooltip>
                                </Box>
                              </Box>

                              <Stack
                                direction="row"
                                spacing={1}
                                sx={{ paddingX: "8px" }}
                              >
                                <Typography
                                  sx={{ fontSize: "14px", fontWeight: 600 }}
                                >
                                  {" "}
                                  {data.specialty?.SPECIALTY_NAME}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    padding: "1px 6px", // Reduce padding
                                    borderRadius: "4px",
                                    color: getStatusColor(ClinicianStatus),
                                    backgroundColor:
                                      getStatusBgColor(ClinicianStatus),
                                  }}
                                >
                                  {getStatusonJobCard(ClinicianStatus)}
                                </Typography>
                              </Stack>

                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  marginTop: 0.1,
                                  paddingX: "8px",
                                }}
                                px={0.1}
                              >
                                {data?.user?.FACILITY_NAME} .{" "}
                                <span>Glendora, CA</span>
                              </Typography>

                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "6px",
                                  paddingX: "8px",
                                }}
                              >
                                <WorkOutlineOutlinedIcon
                                  sx={{ fontSize: "14px" }}
                                />
                                <Typography
                                  sx={{ fontSize: "12px", marginLeft: 0.8 }}
                                >
                                  {" "}
                                  {data?.JOB_TYPE}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "left",
                                  padding: "0px 1px",
                                }}
                              >
                                <Button
                                  className="montserratFont"
                                  sx={{
                                    color: "rgba(0,0,0,0.7)",
                                    fontSize: "11px",
                                    border: "1px solid rgba(0,0,0,0.3)",
                                    justifyContent: "center",
                                    fontWeight: 600,
                                    marginTop: 0.2,
                                  }}
                                >
                                  {data?.jobs_role?.ROLE_NAME}
                                </Button>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mt: 1,
                                  paddingX: "8px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "#3BB9E3",
                                    cursor: "pointer",
                                  }}
                                >
                                  {/* <span className="loraFont">Posted on  {
                          data.CREATED_DATE
                            ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(data.CREATED_DATE).getFullYear()}`
                            : "Latest"
                        }</span> */}
                                  {data.CREATED_DATE
                                    ? format(
                                        new Date(data.CREATED_DATE),
                                        "MMM dd, yyyy",
                                      )
                                    : "Latest"}
                                </Typography>

                                <Tooltip title="View Job">
                                  <Typography
                                    sx={{
                                      color: "#02230C",
                                      fontSize: "12px",
                                      cursor: "pointer",
                                      // textDecoration: "underline",
                                      border: "1px solid #02230C",
                                      padding: "3px 10px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={() => handleCardClick(data)}
                                  >
                                    <span className="loraFont">View Job</span>
                                  </Typography>
                                </Tooltip>
                              </Box>
                            </Card>

                          </Grid>
                        }
                      </Grid>
                    );
                  })}
              </Grid>
            )}

            {offerTabactive === "Rejected" && (
              <Grid
                container
                className={`${offerTabactive === "Rejected" ? "" : "dNone"}`}
              >
                {data?.pages
                  .flatMap((page) => page.OUTPUT)
                  .filter((job, index, array) => array.findIndex(j => j.ID === job.ID) === index)
                  .map((data, index, array) => {
                    const isJobSaved = data?.save_jobs?.[0]?.SAVED || false;

                    const clinicianWithJob =
                      data?.cliniciansInFacilityJobShifts[0];
                    const ClinicianStatus =
                      data?.cliniciansInFacilityJobShifts?.[0]
                        ?.clinicianStatus || "";
                    let isLastElement = index === array?.length - 1;
                    return (
                      <Grid container spacing={2} mt={1}>
                        {
                          <Grid
                            item
                            id="index"
                            ref={isLastElement ? ref : null}
                            xs={12}
                            sm={12}
                            md={6}
                            lg={isDetailsOpen ? 12 : 4}
                          >
                            {/* <!-------------------------------------!> */}

                            {/* Latest Offers Accepted Card Code */}

                            <Card
                              sx={{
                                borderRadius: "8px",
                                marginBottom: 1.5,
                                height: "100%",
                                maxHeight: "240px", // Decreased from 280px
                                padding: "8px", // Reduce padding inside the card
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "0 4px",
                                }}
                              >
                                <img
                                  src={jobRoleImage}
                                  alt="Job Role"
                                  style={{ width: "40px", height: "40px" }}
                                />{" "}
                                {/* Decrease image size */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2px",
                                  }}
                                >
                                  <Tooltip title="Save Job">
                                    <BookmarkBorderOutlinedIcon
                                      key={data.SAVED}
                                      style={{
                                        background: isJobSaved
                                          ? "linear-gradient(to right,#6ebe44,#4eb3e8)"
                                          : "",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSaveJob(data.ID);
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip
                                    title={
                                      data?.HIRING_TYPE === "Self Hire"
                                        ? "Open Posted"
                                        : "Sent by Admin"
                                    }
                                  >
                                    <StarIcon
                                      style={{
                                        color:
                                          data?.HIRING_TYPE === "Self Hire"
                                            ? "gray"
                                            : "gold",
                                      }}
                                    />
                                  </Tooltip>
                                </Box>
                              </Box>

                              <Stack
                                direction="row"
                                spacing={1}
                                sx={{ paddingX: "8px" }}
                              >
                                <Typography
                                  sx={{ fontSize: "14px", fontWeight: 600 }}
                                >
                                  {" "}
                                  {data.specialty?.SPECIALTY_NAME}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    padding: "1px 6px", // Reduce padding
                                    borderRadius: "4px",
                                    color: getStatusColor(ClinicianStatus),
                                    backgroundColor:
                                      getStatusBgColor(ClinicianStatus),
                                  }}
                                >
                                  {getStatusonJobCard(ClinicianStatus)}
                                </Typography>
                              </Stack>

                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  marginTop: 0.1,
                                  paddingX: "8px",
                                }}
                                px={0.1}
                              >
                                {data?.user?.FACILITY_NAME} .{" "}
                                <span>Glendora, CA</span>
                              </Typography>

                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "6px",
                                  paddingX: "8px",
                                }}
                              >
                                <WorkOutlineOutlinedIcon
                                  sx={{ fontSize: "14px" }}
                                />
                                <Typography
                                  sx={{ fontSize: "12px", marginLeft: 0.8 }}
                                >
                                  {" "}
                                  {data?.JOB_TYPE}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "left",
                                  padding: "0px 1px",
                                }}
                              >
                                <Button
                                  className="montserratFont"
                                  sx={{
                                    color: "rgba(0,0,0,0.7)",
                                    fontSize: "11px",
                                    border: "1px solid rgba(0,0,0,0.3)",
                                    justifyContent: "center",
                                    fontWeight: 600,
                                    marginTop: 0.2,
                                  }}
                                >
                                  {data?.jobs_role?.ROLE_NAME}
                                </Button>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mt: 1,
                                  paddingX: "8px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "#3BB9E3",
                                    cursor: "pointer",
                                  }}
                                >
                                  {/* <span className="loraFont">Posted on  {
                          data.CREATED_DATE
                            ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(data.CREATED_DATE).getFullYear()}`
                            : "Latest"
                        }</span> */}
                                  {data.CREATED_DATE
                                    ? format(
                                        new Date(data.CREATED_DATE),
                                        "MMM dd, yyyy",
                                      )
                                    : "Latest"}
                                </Typography>

                                <Tooltip title="View Job">
                                  <Typography
                                    sx={{
                                      color: "#02230C",
                                      fontSize: "12px",
                                      cursor: "pointer",
                                      // textDecoration: "underline",
                                      border: "1px solid #02230C",
                                      padding: "3px 10px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={() => handleCardClick(data)}
                                  >
                                    <span className="loraFont">View Job</span>
                                  </Typography>
                                </Tooltip>
                              </Box>
                            </Card>
                          </Grid>
                        }
                      </Grid>
                    );
                  })}
              </Grid>
            )}
          </Grid>
        )}

        {/* ----------------- Offer  Tab ends here -------------------------------- */}

        {/* ----------------- Applied Job status start here -------------------------------- */}

        <Grid
          item
          lg={isDetailsOpen ? 5 : 12}
          className={`${active === "Applied Job Status" ? "" : "dNone"}`}
          sx={{
            height: `calc(${elemHeight}px - 250px)`,
            overflow: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "#B7B7B7 transparent",
          }}
        >
          <Grid container spacing={1}>
            {appliedtabs?.map((tab) => (
              <Grid item>
                <Tabs
                  title={tab?.title}
                  active={tab?.title == appliedTabactive}
                  onClick={() => {
                    setappliedTabActive(tab?.title);
                    setIsDetailsOpen(false);
                  }}
                />
              </Grid>
            ))}
          </Grid>

          {active === "Applied Job Status" && (
            <>
              <Grid
                container
                className={`${appliedTabactive === "Upcoming" ? "" : "dNone"}`}
              >
                {data?.pages
                  .flatMap((page) => page.OUTPUT)
                  .map((data, index, array) => {
                    const clinicianWithJob =
                      data?.cliniciansInFacilityJobShifts[0];
                    let isLastElement = index === array?.length - 1;
                    return (
                      <Grid container key={index} spacing={2} mb={2}>
                        <Grid
                          item
                          id={index}
                          ref={isLastElement ? ref : null}
                          xs={12}
                          sm={12}
                          md={6}
                          lg={isDetailsOpen ? 12 : 4}
                        >
                          <Card
                            sx={{
                              borderRadius: "8px",
                              marginTop: 2,
                              height: "100%",
                              maxHeight: "240px",
                              marginBottom: 1.5,
                              padding: "8px",
                            }}
                          >
                            {/* Upcoming Label */}
                            <Box
                              sx={{
                                padding: "4px 8px",
                                color: "#3bb9e3",
                                borderRadius: "4px",
                                fontSize: "12px",
                                fontWeight: 500,
                                textAlign: "end",
                                marginBottom: "8px",
                              }}
                            >
                              Upcoming
                            </Box>

                            <Box
                              sx={{
                                margin: "0px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                                padding: "0px 2px",
                              }}
                            >
                              <img src={jobRoleImage} alt="" />
                            </Box>

                            <Typography
                              className="montserratFont"
                              sx={{
                                fontSize: "14px",
                                // color: "rgba(0,0,0,0.87)",
                                paddingX: "8px",
                                fontWeight: 600,
                              }}
                            >
                              {data.specialty?.SPECIALTY_NAME}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "11px",
                                color: "rgba(0,0,0,0.6)",
                                fontWeight: 600,
                                marginTop: 1,
                                paddingX: "8px",
                              }}
                            >
                              {" "}
                              {data?.jobs_role?.ROLE_NAME}
                            </Typography>

                            <Box
                              sx={{
                                // width: "auto",
                                // alignItems: "center",
                                // display: "flex",
                                // fontWeight: 400,
                                // marginTop: "10px",

                                display: "flex",
                                alignItems: "center",
                                marginTop: "5px",
                                paddingX: "8px",
                              }}
                            >
                              <WorkOutlineOutlinedIcon
                                sx={{
                                  color: "rgba(0,0,0,0.6)",
                                  fontSize: "14px",
                                }}
                              />
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: "rgba(0,0,0,0.6)",
                                  marginLeft: 0.8,
                                }}
                              >
                                {data?.JOB_TYPE}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: 0.5,
                              }}
                            >
                              {/* <Typography sx={{ color: "#3BB9E3", fontSize: "12px", fontWeight: 500, cursor: "pointer" }}>
                              <span onClick={() => handleCardClick(data)
                                //  setHidden({ data: data, index: clinicianWithJob?.clinicianStatus })
                              }>
                                New
                              </span>
                            </Typography> */}
                              <Typography
                                sx={{
                                  color: "rgba(0,0,0,0.7)",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  paddingLeft: "8px",
                                }}
                              >
                                <span
                                  onClick={
                                    () => handleCardClick(data)
                                    // setHidden({ data: data, index: clinicianWithJob?.clinicianStatus })
                                  }
                                >
                                  {/* {data.CREATED_DATE ? format(new Date(data.CREATED_DATE), 'MM/dd/yyyy') : "Latest"} */}
                                  {data.CREATED_DATE
                                    ? format(
                                        new Date(data.CREATED_DATE),
                                        "MMM dd, yyyy",
                                      )
                                    : "Latest"}
                                </span>
                              </Typography>

                              <Typography
                                // sx={{ color: "#3BB9E3", fontSize: "12px", fontWeight: 500, cursor: "pointer" }}
                                sx={{
                                  color: "#02230C",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                  // textDecoration: "underline",
                                  border: "1px solid #02230C",
                                  padding: "3px 10px",
                                  borderRadius: "4px",
                                }}
                              >
                                <span
                                  onClick={
                                    () => handleCardClick(data)
                                    //  setHidden({ data: data, index: clinicianWithJob?.clinicianStatus })
                                  }
                                >
                                  View Job
                                </span>
                              </Typography>
                            </Box>
                          </Card>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>

              {/* Ongoing Code */}

              <Grid
                container
                className={`${appliedTabactive === "Ongoing" ? "" : "dNone"}`}
              >
                {data?.pages
                  .flatMap((page) => page.OUTPUT)
                  .map((data, index) => {
                    const clinicianWithJob =
                      data?.cliniciansInFacilityJobShifts[0];
                    const ClinicianStatus =
                      data?.cliniciansInFacilityJobShifts?.[0]
                        ?.clinicianStatus || "";
                    const createdDate = new Date(data.CREATED_DATE);
                    const currentDate = new Date();
                    const daysSinceCreated = differenceInDays(
                      currentDate,
                      createdDate,
                    );
                    return (
                      <Grid container key={index} spacing={2} mb={2} mt={1}>
                        <Grid item id="index" xs={12} sm={12} md={6} lg={isDetailsOpen ? 12 : 4}>
                          {/* <Card sx={{ borderRadius: "8px", marginTop: 2, height: "100%", maxHeight: "240px", marginBottom: 1.5, padding: "8px" }}> */}
                          {/* Job Role Image and Bookmark */}
                          {/* <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}>
                            <img src={jobRoleImage} alt="" />

                          </Box>

                          <Stack direction="row" spacing={1}>
                            <Typography sx={{ fontSize: "14px", fontWeight: 600, paddingX: "8px", }}>
                              {data?.specialty?.SPECIALTY_NAME}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: getStatusColor(ClinicianStatus), // Function to dynamically set color
                                fontWeight: "bold",
                                backgroundColor: getStatusBgColor(ClinicianStatus), // Optional background color
                                padding: "1px 6px",
                                borderRadius: "4px"
                              }}>
                              {getStatusonJobCard(ClinicianStatus)}
                            </Typography>
                          </Stack> */}

                          {/* Job Title */}
                          {/* <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                            {data?.specialty?.SPECIALTY_NAME}
                          </Typography> */}
                          {/* 
                          <Typography sx={{ fontSize: "12px", marginTop: 0.1, paddingX: "8px", }} px={0.1}>
                            {data?.user?.FACILITY_NAME} . <span>Glendora, CA</span>
                          </Typography> */}

                          {/* Job Type */}
                          {/* <Box sx={{ display: "flex", alignItems: "center", mt: 1, paddingX: "8px" }}>
                            <WorkOutlineOutlinedIcon sx={{ color: "rgba(0,0,0,0.6)", fontSize: "14px" }} />
                            <Typography sx={{ fontSize: "12px", color: "rgba(0,0,0,0.6)", marginLeft: 0.8 }}>
                              {data?.JOB_TYPE}
                            </Typography>
                          </Box> */}
                          {/* <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              marginTop: "8px"
                            }}>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: getStatusColor(ClinicianStatus), // Function to dynamically set color
                                fontWeight: "bold",
                                backgroundColor: getStatusBgColor(ClinicianStatus), // Optional background color
                                padding: "2px 8px",
                                borderRadius: "4px"
                              }}>
                              {getStatusonJobCard(ClinicianStatus)}
                            </Typography>
                          </Box> */}
                          {/* Specialty Button */}
                          {/* <Box sx={{ mt: 1 }}>
                            <Button sx={{ fontSize: "12px", border: "1px solid rgba(0,0,0,0.3)", mr: 1 }}>
                              Facility - {data?.user?.FACILITY_NAME}
                            </Button>
                          </Box> */}

                          {/* "Ongoing" or Date Since Created */}
                          {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1.5 }}>
                            {appliedTabactive === "Ongoing" && (
                              <Typography sx={{ color: "#3BB9E3", fontSize: "12px", fontWeight: 600 }}>
                                Ongoing
                              </Typography>
                            )}
                            <Typography sx={{ color: "rgba(0,0,0,0.7)", fontSize: "12px", fontWeight: 600 }}>
                              {daysSinceCreated === 0 ? "Today" : `${daysSinceCreated} days ago`}
                            </Typography>
                          </Box>
                        </Card> */}

                          <Card
                            sx={{
                              borderRadius: "8px",
                              marginBottom: 1.5,
                              height: "100%",
                              maxHeight: "240px", // Decreased from 280px
                              padding: "8px", // Reduce padding inside the card
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0 4px",
                              }}
                            >
                              <img
                                src={jobRoleImage}
                                alt="Job Role"
                                style={{ width: "40px", height: "40px" }}
                              />{" "}
                              {/* Decrease image size */}
                              {/* <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
                              <Tooltip title="Save Job">
                                <BookmarkBorderOutlinedIcon
                                  key={data.SAVED}
                                  // style={{ background: isJobSaved ? "linear-gradient(to right,#6ebe44,#4eb3e8)" : "" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSaveJob(data.ID);
                                  }}
                                />
                              </Tooltip>
                              <Tooltip title={data?.HIRING_TYPE === "Self Hire" ? 'Open Posted' : 'Sent by Admin'}>
                                <StarIcon
                                  style={{
                                    color: data?.HIRING_TYPE === "Self Hire" ? 'gray' : 'gold',
                                  }}
                                />
                              </Tooltip>
                            </Box> */}
                            </Box>

                            <Stack
                              direction="row"
                              spacing={1}
                              sx={{ paddingX: "8px" }}
                            >
                              <Typography
                                sx={{ fontSize: "14px", fontWeight: 600 }}
                              >
                                {" "}
                                {data.specialty?.SPECIALTY_NAME}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  padding: "1px 6px", // Reduce padding
                                  borderRadius: "4px",
                                  color: getStatusColor(ClinicianStatus),
                                  backgroundColor:
                                    getStatusBgColor(ClinicianStatus),
                                }}
                              >
                                {getStatusonJobCard(ClinicianStatus)}
                              </Typography>
                            </Stack>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                marginTop: 0.1,
                                paddingX: "8px",
                              }}
                              px={0.1}
                            >
                              {data?.user?.FACILITY_NAME}
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "6px",
                                paddingX: "8px",
                              }}
                            >
                              <WorkOutlineOutlinedIcon
                                sx={{ fontSize: "14px" }}
                              />
                              <Typography
                                sx={{ fontSize: "12px", marginLeft: 0.8 }}
                              >
                                {" "}
                                {data?.JOB_TYPE}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                padding: "2px 8px",
                              }}
                            >
                              <Button
                                className="montserratFont"
                                sx={{
                                  color: "rgba(0,0,0,0.7)",
                                  fontSize: "11px",
                                  border: "1px solid rgba(0,0,0,0.3)",
                                  justifyContent: "center",
                                  fontWeight: 600,
                                  marginTop: 1,
                                }}
                              >
                                {data?.jobs_role?.ROLE_NAME}
                              </Button>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: 1,
                                paddingX: "8px",
                              }}
                            >
                              {appliedTabactive === "Ongoing" && (
                                <Typography
                                  sx={{
                                    color: "#3BB9E3",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                  }}
                                >
                                  Ongoing
                                </Typography>
                              )}

                              {/* <Typography sx={{ fontSize: "11px", color: "#3BB9E3", cursor: "pointer" }}> */}
                              {/* <span className="loraFont">Posted on  {
                          data.CREATED_DATE
                            ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(data.CREATED_DATE).getFullYear()}`
                            : "Latest"
                        }</span> */}
                              {/* {data.CREATED_DATE ? format(new Date(data.CREATED_DATE), 'MMM dd, yyyy') : "Latest"}

                            </Typography> */}

                              <Tooltip title="View Job">
                                <Typography
                                  sx={{
                                    color: "#02230C",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    // textDecoration: "underline",
                                    border: "1px solid #02230C",
                                    padding: "3px 10px",
                                    borderRadius: "4px",
                                  }}
                                  onClick={() => handleCardClick(data)}
                                >
                                  <span className="loraFont">View Job</span>
                                </Typography>
                              </Tooltip>
                            </Box>
                          </Card>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>

              {/* Completed Code */}
              <Grid
                container
                className={`${appliedTabactive === "Completed" ? "" : "dNone"}`}
              >
                {data?.pages
                  .flatMap((page) => page.OUTPUT)
                  .map((data, index, array) => {
                    const jobDate = new Date(data?.CREATED_DATE);
                    const formattedDate = format(jobDate, "MMMM dd, yyyy");
                    const formattedTime = format(jobDate, "hh:mm a");
                    let isLastElement = index === array?.length - 1;
                    const clinicianWithJob =
                      data?.cliniciansInFacilityJobShifts[0];
                    const ClinicianStatus =
                      data?.cliniciansInFacilityJobShifts?.[0]
                        ?.clinicianStatus || "";
                    return (
                      <Grid container key={index} spacing={2} mb={2}>
                        <Grid
                          item
                          id="index"
                          ref={isLastElement ? ref : null}
                          xs={12}
                          sm={12}
                          md={6}
                          lg={isDetailsOpen ? 12 : 4}
                        >
                          <Card
                            sx={{
                              borderRadius: "8px",
                              marginTop: 2,
                              height: "100%",
                              maxHeight: "240px",
                              marginBottom: 1.5,
                              padding: "8px",
                            }}
                            //  onClick={() => handleCardClick({ ...data, jobsheet: true })
                            //   // setHidden({ data: data, index: "Completed" })
                            // }
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                              }}
                            >
                              <img src={jobRoleImage} alt="" />
                            </Box>

                            {/* Job Title */}
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "rgba(0,0,0,0.87)",
                                fontWeight: 600,
                                paddingX: "8px",
                              }}
                            >
                              {data?.specialty?.SPECIALTY_NAME}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                marginTop: 0.1,
                                paddingX: "8px",
                              }}
                              px={0.1}
                            >
                              {data?.user?.FACILITY_NAME} .{" "}
                              <span>Glendora, CA</span>
                            </Typography>

                            {/* Job Type */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                fontWeight: 400,
                                marginTop: "6px",
                                marginLeft: "8px",
                              }}
                            >
                              <WorkOutlineOutlinedIcon
                                sx={{
                                  color: "rgba(0,0,0,0.6)",
                                  fontSize: "14px",
                                }}
                              />
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: "rgba(0,0,0,0.6)",
                                  marginLeft: 0.8,
                                }}
                              >
                                {data?.JOB_TYPE}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography
                                sx={{
                                  color: "#3BB9E3",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  paddingX: "8px",
                                  marginTop: "4px",
                                }}
                              >
                                Completed
                              </Typography>
                            </Box>

                            {/* Specialty Button */}
                            {/* <Box sx={{ display: "flex", justifyContent: "left", margin: "auto", padding: "auto" }}>
                            <Button sx={{ color: "rgba(0,0,0,0.7)", fontSize: "12px", border: "1px solid rgba(0,0,0,0.3)", justifyContent: "center", marginRight: "10px" }}>
                              Facility - {data?.user?.FACILITY_NAME}
                            </Button>
                          </Box> */}

                            {/* Display Date and Time */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: 1,
                                paddingX: "8px",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "rgba(0,0,0,0.7)",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                }}
                              >
                                {formattedDate} at {formattedTime}
                              </Typography>
                              <Typography
                                // sx={{ color: "#3BB9E3", fontSize: "12px", fontWeight: 500, cursor: "pointer" }}
                                sx={{
                                  color: "#02230C",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                  // textDecoration: "underline",
                                  border: "1px solid #02230C",
                                  padding: "3px 10px",
                                  borderRadius: "4px",
                                }}
                              >
                                <span
                                  onClick={
                                    () =>
                                      handleCardClick({
                                        ...data,
                                        jobsheet: true,
                                      })
                                    // setHidden({ data: data, index: "Completed" })
                                  }
                                >
                                  View Job
                                </span>
                              </Typography>
                            </Box>
                          </Card>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
              <Grid
                container
                className={`${appliedTabactive === "Accepted" ? "" : "dNone"}`}
              >
                {data?.pages
                  .flatMap((page) => page.OUTPUT)
                  ?.map((data, index, array) => {
                    const clinicianWithJob =
                      data?.cliniciansInFacilityJobShifts?.[0];
                    const ClinicianStatus =
                      data?.cliniciansInFacilityJobShifts?.[0]
                        ?.clinicianStatus || "";
                    let isLastElement = index === array?.length - 1;
                    return (
                      <Grid container>
                        {clinicianWithJob?.clinicianId == userDetails?.ID &&
                          clinicianWithJob?.offerStatus === "OfferAccepted" && (
                            <Grid
                              item
                              id="index"
                              ref={isLastElement ? ref : null}
                              xs={12}
                              sm={12}
                              md={6}
                              lg={isDetailsOpen ? 12 : 4}
                            >
                              {/* <Card sx={{ borderRadius: "8px", marginBottom: 2, height: "100%", maxHeight: "270px" }}>
                            <Box
                              sx={{
                                margin: "0px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                              }}>
                              <img src={jobRoleImage} alt="" /> */}
                              {/* <StarOutlinedIcon /> */}
                              {/* <Tooltip title="Save" >
                                <BookmarkBorderOutlinedIcon

                                  onClick={() => {
                                    const val = [...values];
                                    console.log("val", val);
                                    let check = data?.save_jobs[0]?.SAVED;

                                    val[index].SAVED = !saveJob;
                                    setValues(val);
                                    mutateAsync({
                                      USER_ID: userDetails?.ID,
                                      JOB_ID: data?.ID,
                                      SAVED: !saveJob, // Toggle based on current state
                                    });

                                    setSaveJob(!saveJob);
                                  }}
                                />
                              </Tooltip> */}
                              {/* </Box>

                            <Typography
                              sx={{
                                fontSize: "16px",
                                color: "rgba(0,0,0,0.87)",
                                fontWeight: 500,
                              }}>
                              {data?.jobs_role?.ROLE_NAME}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "rgba(0,0,0,0.6)",
                              }}></Typography> */}
                              {/* <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                marginTop: "8px"
                              }}>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: getStatusColor(ClinicianStatus), // Function to dynamically set color
                                  fontWeight: "bold",
                                  backgroundColor: getStatusBgColor(ClinicianStatus), // Optional background color
                                  padding: "2px 8px",
                                  borderRadius: "4px"
                                }}>
                                {getStatusonJobCard(ClinicianStatus)}
                              </Typography>
                            </Box> */}
                              {/* <Typography
                              sx={{
                                fontSize: "16px",
                                color: "rgba(0,0,0,0.87)",
                                fontWeight: 500,
                              }}>
                              {data?.jobs_role?.ROLE_NAME}
                            </Typography> */}
                              {/* <Typography
                              sx={{
                                fontSize: "14px",
                                color: "rgba(0,0,0,0.6)",
                              }}></Typography>
                            <Box
                              sx={{
                                width: "auto",
                                alignItems: "center",
                                display: "flex",
                                fontWeight: 400,

                                marginTop: "10px",
                              }}>
                              <WorkOutlineOutlinedIcon
                                sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }}
                              />
                              <Typography
                                sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }}
                                ml={1}>
                                {data?.JOB_TYPE}
                              </Typography>
                            </Box> */}
                              {/* <Box
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                                margin: "auto",
                                fontWeight: 400,
                                marginBottom: "10px",
                              }}>
                              {" "}
                              <Typography
                                ml={1}
                                sx={{
                                  fontSize: "14px",
                                  color: "rgba(0,0,0,0.6)",
                                  fontWeight: 400,
                                }}>
                                {/* <span onClick={() => setHidden({ data: data, index: clinicianWithJob?.offerStatus })}>New</span> */}
                              {/* <span onClick={() =>
                                  // handleCardClick(data)

                                }>New</span>
                              </Typography> */}

                              {/* <Button
                                sx={{
                                  color: "rgba(0,0,0,0.7)",
                                  fontSize: "12px",
                                  border: "1px solid rgba(0,0,0,0.3)",
                                  justifyContent: "center",
                                  marginRight: "10px",
                                }}>
                                Facility - {data?.user?.FACILITY_NAME}
                              </Button>
                            </Box>  */}
                              {/* <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: 1.5,
                              }}>
                              <Typography
                                ml={1}
                                sx={{
                                  color: "#3BB9E3",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                }}>
                                {" "}
                                <span onClick={() => handleCardClick(data)

                                }>New</span>
                              </Typography> */}

                              {/* 
                              <Typography
                                sx={{
                                  color: "rgba(0,0,0,0.7)",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                }}>
                                {" "}
                                <span onClick={() => handleCardClick(data)
                                  //  setHidden({ data: data, index: clinicianWithJob?.clinicianStatus })
                                }>
                                  {" "}
                                  {/* {new Date().getDate(data.CREATED_DATE) -
                                    new Date(new Date()).getDate() || "Latest"} */}
                              {/* {data.CREATED_DATE ? format(new Date(data.CREATED_DATE), 'MMM dd, yyyy') : "Latest"}
                                </span>
                              </Typography>
                            </Box>
                          </Card>  */}

                              {/* <!-------------------------------------!> */}
                              {/* Latest Applied Job Card Code */}
                              <Card
                                sx={{
                                  borderRadius: "8px",
                                  marginBottom: 1.5,
                                  height: "100%",
                                  maxHeight: "240px", // Decreased from 280px
                                  padding: "8px", // Reduce padding inside the card
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "0 4px",
                                  }}
                                >
                                  <img
                                    src={jobRoleImage}
                                    alt="Job Role"
                                    style={{ width: "40px", height: "40px" }}
                                  />{" "}
                                  {/* Decrease image size */}
                                  {/* <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        <Tooltip title="Save Job">
                        <BookmarkBorderOutlinedIcon
                            key={data.SAVED}
                            style={{ background: isJobSaved ? "linear-gradient(to right,#6ebe44,#4eb3e8)" : "" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSaveJob(data.ID);
                            }}
                          />
                        </Tooltip>
                        <Tooltip title={data?.HIRING_TYPE === "Self Hire" ? 'Open Posted' : 'Sent by Admin'}>
                          <StarIcon
                            style={{
                              color: data?.HIRING_TYPE === "Self Hire" ? 'gray' : 'gold',
                            }}
                          />
                        </Tooltip>
                      </Box> */}
                                </Box>

                                <Stack
                                  direction="row"
                                  spacing={1}
                                  sx={{ paddingX: "8px" }}
                                >
                                  {/* <Typography sx={{ fontSize: "14px", fontWeight: 600 }}> {data.specialty?.SPECIALTY_NAME}</Typography> */}
                                  <Typography
                                    sx={{ fontSize: "14px", fontWeight: 600 }}
                                  >
                                    {data?.jobs_role?.ROLE_NAME}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      padding: "1px 6px", // Reduce padding
                                      borderRadius: "4px",
                                      color: getStatusColor(ClinicianStatus),
                                      backgroundColor:
                                        getStatusBgColor(ClinicianStatus),
                                    }}
                                  >
                                    {getStatusonJobCard(ClinicianStatus)}
                                  </Typography>
                                </Stack>

                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    marginTop: 0.1,
                                    paddingX: "8px",
                                  }}
                                  px={0.1}
                                >
                                  {data?.user?.FACILITY_NAME} .{" "}
                                  <span>Glendora, CA</span>
                                </Typography>

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "left",
                                    padding: "0px 1px",
                                  }}
                                >
                                  <Button
                                    className="montserratFont"
                                    sx={{
                                      color: "rgba(0,0,0,0.7)",
                                      fontSize: "11px",
                                      border: "1px solid rgba(0,0,0,0.3)",
                                      justifyContent: "center",
                                      fontWeight: 600,
                                      marginTop: 0.2,
                                    }}
                                  >
                                    {data?.jobs_role?.ROLE_NAME}
                                  </Button>
                                </Box>

                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "6px",
                                  }}
                                >
                                  <WorkOutlineOutlinedIcon
                                    sx={{ fontSize: "14px" }}
                                  />
                                  <Typography
                                    sx={{ fontSize: "12px", marginLeft: 0.8 }}
                                  >
                                    {data?.JOB_TYPE}
                                  </Typography>
                                </Box>

                                {/* <Box sx={{ display: "flex", alignItems: "center", marginTop: "6px", paddingX: "8px", }}>
                      <MonetizationOnOutlinedIcon sx={{ fontSize: "14px" }} />
                      <Typography sx={{ fontSize: "12px", marginLeft: 0.8 }}>
                        {`$${data.PAY_AMOUNT_FROM}-$${data.PAY_AMOUNT_TO}/hr`}
                      </Typography>
                    </Box> */}

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mt: 1,
                                    paddingX: "8px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "11px",
                                      color: "#3BB9E3",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {/* <span className="loraFont">Posted on  {
                          data.CREATED_DATE
                            ? `${new Date(data.CREATED_DATE).getDate()} ${new Date(data.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(data.CREATED_DATE).getFullYear()}`
                            : "Latest"
                        }</span> */}
                                    {data.CREATED_DATE
                                      ? format(
                                          new Date(data.CREATED_DATE),
                                          "MMM dd, yyyy",
                                        )
                                      : "Latest"}
                                  </Typography>

                                  <Tooltip title="View Job">
                                    <Typography
                                      sx={{
                                        color: "#02230C",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        // textDecoration: "underline",
                                        border: "1px solid #02230C",
                                        padding: "3px 10px",
                                        borderRadius: "4px",
                                      }}
                                      onClick={() => handleCardClick(data)}
                                    >
                                      <span className="loraFont">View Job</span>
                                    </Typography>
                                  </Tooltip>
                                </Box>
                              </Card>
                            </Grid>
                          )}
                      </Grid>
                    );
                  })}
              </Grid>
            </>
          )}
        </Grid>

        {isDetailsOpen && selectedJob && (
          <Grid item lg={7}>
            {" "}
            <Button onClick={handleCloseDetails}>Close</Button>
            {data && (
              <JobCardDetails
                data={selectedJob}
                onSaved={() => {
                  dispatch(setSelectedCard(selectedCard));
                  setTimeout(() => {
                    refetch();
                    setIsDetailsOpen(false);
                    setSelectedJob(null);
                  }, 10);
                  // setCheckStatus(selectedCard)

                  handleCardClick(selectedJob);
                }}
              />
            )}
          </Grid>
        )}
      </Grid>

      <Modal
        open={showModal}
        onClose={() =>
          dispatch(setSelectedCard({ ...selectedCard, showModal1: false }))
        }
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <Card sx={style}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Card sx={{ width: 400, p: 2, boxShadow: 3 }}>
              <CardContent>
                <Typography
                  gutterBottom
                  sx={{
                    fontSize: "24px",
                    fontWeight: 600,
                    color: "#000000",
                    opacity: "87%",
                  }}
                >
                  Share Job
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    marginTop: "1.5rem",
                  }}
                  value={originalUrl}
                  disabled={true}
                />
                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <Button
                    id="Copy"
                    onClick={Copy}
                    variant="contained"
                    className="custombuttons"
                  >
                    Copy Link
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Card>
      </Modal>
    </>
  );
}
